import { WORLD_COUNTRY_SHAPES } from '../world-map-country-shapes.js';

const MAP_WIDTH = 2000;
const MAP_HEIGHT = 1001;

function markerPosition(latitude: number, longitude: number): { x: number; y: number } {
	return {
		x: ((Math.max(-180, Math.min(180, longitude)) + 180) / 360) * MAP_WIDTH,
		y: ((90 - Math.max(-90, Math.min(90, latitude))) / 180) * MAP_HEIGHT,
	};
}

export function VisitorLocationMap({
	countryCode,
	label,
	latitude,
	longitude,
}: {
	countryCode?: string;
	label: string;
	latitude?: number;
	longitude?: number;
}) {
	const selectedCountry = countryCode?.trim().toUpperCase();
	const marker =
		latitude === undefined || longitude === undefined
			? undefined
			: markerPosition(latitude, longitude);

	return (
		<div className="visitor-location-map">
			<svg
				aria-label={`Map showing ${label}`}
				role="img"
				viewBox={`0 0 ${MAP_WIDTH} ${MAP_HEIGHT}`}
			>
				{WORLD_COUNTRY_SHAPES.map(({ id, shape }) => (
					<path
						className={id === selectedCountry ? 'selected' : undefined}
						d={shape}
						key={id}
					/>
				))}
				{marker && (
					<g
						className="visitor-map-marker"
						transform={`translate(${marker.x} ${marker.y})`}
					>
						<circle className="visitor-map-marker-ring" r="23" />
						<circle r="11" />
					</g>
				)}
			</svg>
			{!marker && <span>Approximate coordinates unavailable</span>}
		</div>
	);
}
